import {stringifyId} from '../../../../types'
import type {BuildId} from '../../../../types'

export const getOwnTestsLocator = (buildLocator: string): string => `build:(${buildLocator})`

export const getAllTestsLocator = (buildId: BuildId): string =>
  `build:(snapshotDependency(to:(id:${stringifyId(
    buildId,
  )}),includeInitial:true),composite:false,defaultFilter:false)`
